import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneDownFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m17.22 15.987 5.654 1.009c3.92-6.969-3.04-9.998-10.89-9.996S-2.784 10.033 1.126 17l5.654-1.011 1.005-2.556c.17-.434.51-.78.964-.892.64-.158 1.721-.346 3.234-.347 1.52 0 2.604.19 3.244.348.448.112.785.451.957.878z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PhoneDownFilledSize24Glyph.displayName = 'PhoneDownFilledSize24Glyph';
